import useFetchApi from "@/api/hooks/useFetchApi";
import Loader from "@/components/Loader/loader";
import MyRoutes from "@/components/Routes";
import Slider from "@/components/Slider";
import { Dispatch } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, Outlet } from "react-router-dom";

const Home: React.FC = () => {

    const {
        data: hakkimizdaData,
        isLoading: hakkimizdaLoading,
        error: hakkimizdaError
    } = useFetchApi({
        url: '/v1/gp/6787af0ad187a284903ccab1/tr/6788b9fe60eb571bc6d78d0b/detail',
        service: "CMS_PROC"
    })

    const {
        data: hizmetlerData,
        isLoading,
        error
    } = useFetchApi({
        url: '/v1/gp/6787af0ad187a284903ccab1/tr/find?list_related=false&list_referenced=false&module_populate=6787a9e4d187a284903cbcd4&limit=0&skip=0&search=title%3A%24eq%3AHizmetler',
        service: "CMS_PROC"
    });

    const disptach: Dispatch = useDispatch();

    useEffect(() => {
        disptach({
            type: "page/setGlobalLoading",
            payload: true
        })
    }, []);

    const [sliderIsLoaded, setSliderLoaded] = useState(false);
    useEffect(() => {
        if (hakkimizdaData && hizmetlerData && sliderIsLoaded) {
            disptach({
                type: "page/setGlobalLoading",
                payload: false
            })
        }
    }, [hakkimizdaData, hizmetlerData, sliderIsLoaded]);

    return (
        <>
            {/* <MyRoutes /> */}

            <Slider
                setLoaded={() => {
                    setSliderLoaded(true)
                }}
            />

            {/* Hakkımızda Özet */}
            <section className="ls section_padding_top_50 section_padding_bottom_40 columns_margin_bottom_60">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3">
                            <h2 className="section_header">
                                {hakkimizdaData?.title}
                            </h2>
                            <hr className="divider_2_30 left-important main_bg_color divider_35" />
                            <Link to="/hakkimizda" className="theme_button color1 topmargin_10">Daha Fazla</Link>
                        </div>
                        <div className="col-md-9">
                            <p className="entry-excerpt highlight2 bottommargin_30" dangerouslySetInnerHTML={{ __html: hakkimizdaData?.content }}></p>

                            <p dangerouslySetInnerHTML={{ __html: hakkimizdaData?.metin1 }}></p>

                        </div>
                    </div>
                </div>
            </section>

            {/* Faaliyetlerimiz */}
            <section className="ls section_padding_top_100 section_padding_bottom_75 custom_page_services">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3 text-center text-sm-left">
                            <h2 className="section_header">
                                Hizmet
                                <br />
                                <span className="highlight">Portföyümüz</span>
                            </h2>
                            <hr className="divider_2_30 left main_bg_color divider_35" />
                        </div>
                        <div className="col-md-9">
                            {hizmetlerData?.results?.map((result: any, resultIndex: number) =>
                                result?.populated?.["Anasayfa İçerikler"]?.records.reduce(
                                    (acc: any[][], item: any, index: number) => {
                                        if (index % 3 === 0) acc.push([]);
                                        acc[acc.length - 1].push(item);
                                        return acc;
                                    },
                                    []
                                ).map((group: any[], groupIndex: number) => (
                                    <div className="row services-row customServiceRow" key={`group-${resultIndex}-${groupIndex}`}>
                                        {group.map((item: any, itemIndex: number) => (
                                            <div className="col-sm-4 col-xs-6" key={`${resultIndex}-${groupIndex}-${itemIndex}`}>
                                                <div className="teaser">
                                                    <div className="main_bg_color1 size_normal">
                                                        <img src={item.icon} alt="Icon" />
                                                    </div>
                                                    <h4 className="text-uppercase">
                                                        <Link to="#">{item.title}</Link>
                                                    </h4>
                                                    <hr className="divider_2_30 left main_bg_color" />
                                                    <p dangerouslySetInnerHTML={{ __html: item?.content }}></p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    <div className="row columns_margin_0">
                        <div className="col-sm-12 text-center text-sm-left">
                            <Link to="/urunler" className="theme_button color1 services_button">Ürünlerimiz</Link>
                        </div>
                    </div>
                </div>
            </section>

            <Outlet />
        </>
    );
}

export default Home;
